/** Number formatting for engineers: 3 significant figures, × 10ⁿ outside 0.001–9999 (plan §8.8). */

const SUPERSCRIPT: Record<string, string> = { '-': '⁻', '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴', '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹' };

export function formatNumber(value: number | null | undefined, sig = 3): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  if (value === 0) return '0';
  const abs = Math.abs(value);
  if (abs >= 0.001 && abs < 10_000) {
    const s = value.toPrecision(sig);
    // drop exponent forms toPrecision can still produce (e.g. 1.00e+3)
    return s.includes('e') ? String(Number(s)) : s;
  }
  const [mantissa = '', exp = '0'] = value.toExponential(sig - 1).split('e');
  const e = String(Number(exp)).split('').map((c) => SUPERSCRIPT[c] ?? c).join('');
  return `${mantissa} × 10${e}`;
}

/** Full precision for hover titles. */
export const fullPrecision = (value: number | null | undefined): string =>
  value === null || value === undefined || !Number.isFinite(value) ? '' : String(Number(value.toPrecision(12)));

export const UNIT_LABEL: Record<string, string> = {
  'm3/s': 'm³/s', m2: 'm²', m3: 'm³', 'kg/m3': 'kg/m³', '1': '', 'vol/vol': 'vol/vol',
};
export const unitLabel = (u: string): string => UNIT_LABEL[u] ?? u;
